import { TrackingModule } from "../helpers/TrackingHelper";

export class SlickTrackingModule {
     constructor() {
         this.init();
     }
     slickItems() {		
         var _this = this;
         
         //Carousel dots
         $('.slick-dots li').on('click', 'button', function () {
             //const trackingModule = new TrackingModule()
             //var name = $(this).text();
             //trackingModule.gaTrackEvent("Carousel", "Click", "Current URL: " + window.location.href + ", Name: dot " + name, undefined, false);
         });	
     }
    
     init() {
         this.slickItems();
     }
}

